class StorageClient {

  initialize(store = {}, callback = () => {

  }) {

    this.getItem = (key, callback = () => {}) => {
        window.getItem(key, callback)
    }

    this.getItems = (key, callback = () => {}) => {
        window.getItems(key, callback)
    }

    this.setItem = (key, value, callback = () => {}) => {
        window.setItem(key, value, callback)
    }

    this.removeItem = (key, callback = () => {}) => {
      window.removeItem(key, callback)
    }

    callback()

  }


}

const storageClient = new StorageClient();

export default storageClient;



// WEBPACK FOOTER //
// ./src/services/Storage/index.js